import { SignOut } from '@phosphor-icons/react'
import { Icon } from '@shopflo/ui'
import { useAuth } from 'src/lib/contexts/AuthContext'
import { useUser } from 'src/lib/contexts/UserContext'
import { useLocale } from 'src/lib/hooks/useLocal'
import useNavigation from 'src/lib/hooks/useNavigation'
import { hasAuthCookie } from 'src/lib/utils/helpers'
import { formatUserName } from 'src/lib/utils/user'

const UserProfileSection = ({ closePopover }: { closePopover: () => void }) => {
  const { user } = useUser()

  const {
    actions: { resetAndRedirect }
  } = useNavigation()

  const { t } = useLocale()

  const { logout } = useAuth()

  const userInitial = user?.firstName?.charAt(0)?.toUpperCase()
  const userEmail = user?.email

  const userName = formatUserName(user?.firstName, user?.lastName)

  return (
    <div className='px-1.5 pt-1.5 pb-2 flex flex-col bg-zinc-50'>
      <div
        className='flex p-2 gap-2 hover:bg-zinc-100 rounded-md cursor-pointer'
        id='profile-section-trigger'
        onClick={() => {
          closePopover()
          resetAndRedirect('/settings/profile')
        }}
      >
        <div className='min-w-5 h-5 text-xs font-semibold rounded-md bg-teal-600/10 flex items-center justify-center text-teal-600'>
          {userInitial}
        </div>
        <div className='flex flex-col min-w-0 flex-1'>
          <p className='text-zinc-600 text-sm'>{userName}</p>
          <p className='text-zinc-500 text-xs truncate'>{userEmail}</p>
        </div>
      </div>
      <div
        className='items-center justify-between px-2 py-1.5 hover:bg-zinc-100 rounded-md cursor-pointer'
        onClick={() => logout()}
        id='sign-out'
      >
        <div className='flex items-center gap-2'>
          <div className='w-5 h-5 flex items-center justify-center'>
            <Icon IconComponent={SignOut} size='sm' className='text-zinc-500' />
          </div>
          <p className='text-zinc-600 text-sm'>{t('sign_out')}</p>
        </div>
      </div>
    </div>
  )
}

export default UserProfileSection
